<mat-card class="flex flex-col flex-auto w-full p-6 ">
<div class="mat-row">
  <div class="mat-col-lg-12 mat-col-md-12">
    <button mat-flat-button color="primary" style="float:right; padding: 7px; border-radius: 2px;" class="bg-blue-500 text-white" (click)="goback()">Back</button>
  </div>
</div>


  <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-6">
    <div *ngIf="CreateTicketDtls && CreateTicketDtls.length > 1" class="col-span-1">
      <div class="form-label">Select Type</div>
      <mat-form-field appearance="fill" class="w-full">
        <mat-select [(ngModel)]="TypeID" (selectionChange)="ForCategory()" required>
          <mat-option *ngFor="let d of CreateTicketDtls" [value]="d.tckt_type_id">{{ d.tckt_type_nm }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="CreateTicketDtls && CreateTicketDtls.length == 1" class="col-span-1">
      <div class="form-label">Type</div>
      <div class="lbl_cntnt typeName">{{ CreateTicketDtls[0].tckt_type_nm }}</div>
    </div>

    <div *ngIf="CategoryDtls && CategoryDtls.length > 1" class="col-span-1">
      <div class="form-label">Select Category</div>
      <mat-form-field appearance="fill" class="w-full">
        <mat-select [(ngModel)]="categryID" (selectionChange)="ForSubCategory()" required>
          <mat-option *ngFor="let d of CategoryDtls" [value]="d.tckt_ctgry_id">{{ d.tckt_ctgry_nm }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="CategoryDtls && CategoryDtls.length == 1" class="col-span-1">
      <div class="form-label">Category</div>
      <div class="lbl_cntnt typeName">{{ CategoryDtls[0].tckt_ctgry_nm }}</div>
    </div>
    <div *ngIf="(!CategoryDtls && shwctgry == false) || (CategoryDtls.length < 1 && shwctgry == false) || (!CategoryDtls.length && shwctgry == false)" class="col-span-1">
      <div class="form-label">Category</div>
      <mat-form-field appearance="fill" class="w-full">
        <mat-select [(ngModel)]="categryID" (selectionChange)="ForSubCategory()" required>
          <mat-option *ngFor="let d of CategoryDtls" [value]="d.tckt_ctgry_id">{{ d.tckt_ctgry_nm }}</mat-option>
        
        </mat-select>
      </mat-form-field>
      
    </div>

    <div *ngIf="subCategoryDtls && subCategoryDtls.length > 1" class="col-span-1">
      <div class="form-label">Select Sub-Category</div>
      <mat-form-field appearance="fill" class="w-full">
        <mat-select [(ngModel)]="subcategryID" required>
          <mat-option *ngFor="let d of subCategoryDtls" [value]="d.tckt_sb_ctgry_id">{{ d.tckt_sb_ctgry_nm }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="subCategoryDtls && subCategoryDtls.length == 1" class="col-span-1">
      <mat-form-field>
      <div class="form-label">Sub-Category</div>
      <div class="lbl_cntnt typeName">{{ subCategoryDtls[0].tckt_sb_ctgry_nm }}</div>
    </mat-form-field>
    </div>
    <div *ngIf="(!subCategoryDtls && shwsbctgry == false) || (subCategoryDtls.length < 1 && shwsbctgry == false) || (!subCategoryDtls.length && shwsbctgry == false)" class="col-span-1">
      <div class="form-label">Sub-Category</div>
      <mat-form-field appearance="fill" class="w-full">
        <mat-select [(ngModel)]="subcategryID" required>
          <mat-option *ngFor="let d of subCategoryDtls" [value]="d.tckt_sb_ctgry_id">{{ d.tckt_sb_ctgry_nm }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-6">
    <div class="col-span-1 lg:col-span-2">
      <div class="form-label">Short Note <span class="reqSgnColor">*</span></div>
      <mat-form-field appearance="fill" class="w-full">
        <textarea matInput [(ngModel)]="shrtdescn" required></textarea>
        <mat-error>Note is required</mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="grid grid-cols-1 mt-6">
    <div class="col-span-1">
      <div class="form-label">Description <span class="reqSgnColor">*</span></div>
      <mat-form-field appearance="fill" class="w-full">
        <textarea matInput [(ngModel)]="lngdescn" required></textarea>
        <mat-error>Description is required</mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="grid grid-cols-12 gap-4" style="margin-top: 30px;">
    <div class="col-span-4">
      <div class="form-label font-medium">Upload Image/Document</div>
      <!-- *ngIf="!fnlImgs" -->
      <div *ngIf="!fnlImgs">
        <label>
          <input id="imageUpload" style="display:none" type="file" [(ngModel)]="app_icon" accept=".xlsx, .xls, .csv, .png, .jpg, .jpeg" (change)="onSelectFile($event)">
          <span class="btn btn-primary font-size-16 font-weight-600  border-radius-3 uploadImggBtn">
       
            <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="upload" style="margin-top: 38px;"></mat-icon>
          </span>
        </label>
      </div>
      <div *ngIf="fnlImgs">
        <mat-icon color="warn" class="close-icn" style="float:right;" matTooltip="Remove this image" (click)="removeImg()">X</mat-icon>
        <img [src]="fnlImgs" height="150" width="200">
        <div>{{selectedFile}}</div>
      </div>
    </div>
  </div>

  <div class="flex justify-center mt-6">
    <button mat-raised-button color="primary" class="bg-blue-500 text-white" (click)="saveform()">Save</button>
    <button mat-raised-button class="ml-4" (click)="resetform()">Reset</button>
  </div>
</mat-card>
